import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from 'ensightful-koala-ui';

import { Subtitle3 } from 'components/atoms/Text';
import { handleKeyPress } from 'utils/helper';

const ButtonContainer = styled.div`
    background-color: white;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 14px;
    padding-right: 14px;
    margin-top: 10px;
    margin-bottom: 10px;

    &:hover {
        cursor: pointer;
    }
`;

const CollapsableButtonWrapper = styled.div`
    position: relative;
`;

const CollapsableChidren = styled.div`
    positoin: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: ${(props) => (props.open ? 'fit-content' : '0px')};
    display: ${(props) => (props.open ? 'block' : 'none')};
`;

const CollapsableButton = ({ className, defaultOpen, text, children, ...props }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <CollapsableButtonWrapper className={className}>
            <ButtonContainer
                tabIndex={0}
                kind={'complete'}
                onClick={() => setOpen((prev) => !prev)}
                onKeyPress={handleKeyPress(() => setOpen((prev) => !prev))}
                {...props}
            >
                {typeof text === 'string' ? <Subtitle3>{text}</Subtitle3> : text}
                {open ? <Icon kind={'drop-up-arrow'} size={10} /> : <Icon kind={'drop-down-arrow'} size={10} />}
            </ButtonContainer>
            <CollapsableChidren open={open}>{children}</CollapsableChidren>
        </CollapsableButtonWrapper>
    );
};

export default CollapsableButton;
